import React from 'react'
import Image from '@/components/Image'

function ImageOverlayLink({ children, imageProps, linkProps }) {
  return (
    <a
      className="relative block overflow-hidden rounded-xl"
      href={linkProps.href}
      target={linkProps.target}
      title={linkProps.title}
    >
      <Image {...imageProps} />
      <div
        className="absolute inset-0 flex items-center justify-center
        bg-gray-1100/30  p-8 text-center text-lg
        font-semibold leading-6
        tracking-normal text-white
        md:text-xl md:leading-8 lg:text-2xl lg:leading-8 lg:tracking-normal"
      >
        {children}
      </div>
    </a>
  )
}

export default ImageOverlayLink
